var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapTrackObject } from "../tracks/map";
import { mapClientPreviewObjectToClient } from "../shared/client";
export var mapPlaylistPreviewObject = function (object) {
    var base = {
        id: object.id,
        title: object.title,
        createdAt: object.created_at,
        updatedAt: object.updated_at,
        duration: {
            formatted: object.formatted_total_duration,
        },
        trackCount: object.track_count,
        isPublished: object.is_published,
        canBeDeleted: object.canDelete,
    };
    if (object.client_id !== null) {
        return __assign(__assign({}, base), { type: "private", clientLogin: object.client_login, client: object.client
                ? mapClientPreviewObjectToClient(object.client)
                : {
                    id: object.client_id,
                    contractNumber: "\u043A\u043B\u0438\u0435\u043D\u0442 #" + object.client_id,
                    contractDate: null,
                    showDetails: false,
                    createdAt: "",
                } });
    }
    var publicPlaylist = object;
    return __assign({ type: "public", businessTypes: publicPlaylist.business_types, imagePath: publicPlaylist.image }, base);
};
export var mapPlaylistDetailObject = function (object) {
    var playlist = mapPlaylistPreviewObject(object);
    return __assign(__assign({}, playlist), { duration: __assign(__assign({}, playlist.duration), { seconds: object.total_duration }), tracks: object.tracks.map(mapTrackObject) });
};
